module.exports = __webpack_public_path__ + "img/UI_common_framelabelPF_01_acbb6b732.png";